var _ = require('underscore');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;
var Validation = require('validation');

var Comments = Marionette.View.extend({
    events: {
        'blur @ui.returnReason': 'update'
    },
    initialize: function () {
        Validation.bind(this);
    },
    template: '#dialogReturn',
    ui: {
        returnReason: '#returnReason'
    },
    update: function () {
        this.model.set('returnReason', this.ui.returnReason.val());
    }
});

module.exports.show = function (options) {
    var model = options.model;
  
    model.validation = _.extend(model.validation, {
        returnReason: function () { return this.get('returnReason') === '' ? Labels.Required : ''; }
    });
    return Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.Yes,
        validate: model,
        view: new Comments({
            model: model
        })
    }).always(function () {
        model.validation.returnReason = _.noop;
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogReturn.js